module.exports = __webpack_public_path__ + "img/product-3.f1920d65.jpg";